import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import CustomModal from './CustomModal';

function CompanyListPage({ showToast, user, onSwitch }) {
  var [modal, setModal] = useState(null);
  var closeModalDialog = function() { setModal(null); };
  var [companies, setCompanies] = useState([]);
  var [activeId, setActiveId] = useState(0);
  var [search, setSearch] = useState('');
  var [sortKey, setSortKey] = useState('name');
  var [sortDir, setSortDir] = useState('asc');
  var [loading, setLoading] = useState(true);
  var [addOpen, setAddOpen] = useState(false);
  var [addForm, setAddForm] = useState({ name: '', ceo: '', bizNo: '', address: '', tel: '', email: '' });
  var [addLoading, setAddLoading] = useState(false);
  // 단일 OCR
  var [ocrFile, setOcrFile] = useState(null);
  var [ocrPreview, setOcrPreview] = useState(null);
  var [ocrLoading, setOcrLoading] = useState(false);
  var [imgScale, setImgScale] = useState(1);
  var [imgPos, setImgPos] = useState({ x: 0, y: 0 });
  var [isDragging, setIsDragging] = useState(false);
  var [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  // 다중 OCR (doc_agency/admin)
  var [batchItems, setBatchItems] = useState([]);
  var [batchProcessing, setBatchProcessing] = useState(false);
  var [batchDone, setBatchDone] = useState(0);
  var [batchPreviewIdx, setBatchPreviewIdx] = useState(null);

  var canBatch = user && (user.role === 'doc_agency' || user.role === '관리자' || user.role === 'admin');
  var isAdmin = user && (user.role === '관리자' || user.role === 'admin');

  var fetchCompanies = function() {
    authFetch(API + '/auth/my-companies').then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) { setCompanies(d.companies || []); setActiveId(d.activeCompanyId || 0); }
      setLoading(false);
    }).catch(function() { setLoading(false); });
  };

  useEffect(function() { fetchCompanies(); }, []);

  var switchCompany = function(companyId) {
    authFetch(API + '/auth/switch-company', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ companyId: companyId })
    }).then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) { localStorage.setItem('autodoc_token', d.token); if(d.user)sessionStorage.setItem('autodoc_user',JSON.stringify(d.user)); setActiveId(companyId); if (onSwitch) onSwitch(d.user); showToast('업체 전환 완료'); window.location.reload(); }
      else { showToast(d.error || '전환 실패', 'err'); }
    }).catch(function() { showToast('서버 오류', 'err'); });
  };

  var addCompany = function() {
    if (!addForm.name) { showToast('업체명 필수', 'err'); return; }
    setAddLoading(true);
    authFetch(API + '/auth/add-company', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(addForm)
    }).then(function(r) { return r.json(); }).then(function(d) {
      setAddLoading(false);
      if (d.success) { showToast('사업자 추가 완료'); closeModal(); fetchCompanies(); }
      else { showToast(d.error || '추가 실패', 'err'); }
    }).catch(function() { setAddLoading(false); showToast('서버 오류', 'err'); });
  };

  var closeModal = function() {
    setAddOpen(false); setAddForm({ name: '', ceo: '', bizNo: '', address: '', tel: '', email: '' });
    setOcrFile(null); setOcrPreview(null); setImgScale(1); setImgPos({ x: 0, y: 0 });
    setBatchItems([]); setBatchDone(0); setBatchPreviewIdx(null);
  };

  // 단일 OCR
  var handleOcrFile = function(file) {
    if (!file) return;
    setOcrFile(file); setOcrPreview(URL.createObjectURL(file));
    setImgScale(1); setImgPos({ x: 0, y: 0 }); setOcrLoading(true);
    var fd = new FormData(); fd.append('image', file);
    authFetch(API + '/admin/companies/ocr-biz-license', { method: 'POST', body: fd })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        setOcrLoading(false);
        if (d.success && d.data) {
          setAddForm(function(p) { return { name: d.data.name || p.name, ceo: d.data.ceo || p.ceo, bizNo: d.data.bizNo || p.bizNo, address: d.data.address || p.address, tel: d.data.tel || p.tel, email: p.email }; });
        } else { showToast('OCR 인식 실패', 'err'); }
      }).catch(function() { setOcrLoading(false); showToast('OCR 서버 오류', 'err'); });
  };

  // 다중 OCR
  var handleBatchFiles = function(fileList) {
    var files = []; for (var i = 0; i < fileList.length; i++) files.push(fileList[i]);
    if (files.length === 1 && !canBatch) { handleOcrFile(files[0]); return; }
    if (files.length === 1 && canBatch) { handleOcrFile(files[0]); return; }
    var items = files.map(function(f) { return { file: f, preview: URL.createObjectURL(f), name: '', ceo: '', bizNo: '', address: '', tel: '', status: 'pending', checked: true }; });
    setBatchItems(items); setBatchDone(0); setBatchProcessing(true);
    // 순차 OCR
    var processNext = function(idx) {
      if (idx >= items.length) { setBatchProcessing(false); return; }
      var fd = new FormData(); fd.append('image', items[idx].file);
      authFetch(API + '/admin/companies/ocr-biz-license', { method: 'POST', body: fd })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          setBatchItems(function(prev) {
            var next = prev.slice();
            if (d.success && d.data) {
              next[idx] = Object.assign({}, next[idx], { name: d.data.name || '', ceo: d.data.ceo || '', bizNo: d.data.bizNo || '', address: d.data.address || '', tel: d.data.tel || '', status: 'done' });
            } else { next[idx] = Object.assign({}, next[idx], { status: 'fail' }); }
            return next;
          });
          setBatchDone(function(p) { return p + 1; });
          processNext(idx + 1);
        }).catch(function() {
          setBatchItems(function(prev) { var next = prev.slice(); next[idx] = Object.assign({}, next[idx], { status: 'fail' }); return next; });
          setBatchDone(function(p) { return p + 1; });
          processNext(idx + 1);
        });
    };
    processNext(0);
  };

  // 일괄 등록
  var batchAddAll = function() {
    var toAdd = batchItems.filter(function(it) { return it.checked && it.name; });
    if (toAdd.length === 0) { showToast('추가할 업체를 선택하세요', 'err'); return; }
    setAddLoading(true);
    var done = 0; var fail = 0;
    var addNext = function(idx) {
      if (idx >= toAdd.length) {
        setAddLoading(false);
        showToast(done + '개 추가 완료' + (fail > 0 ? ', ' + fail + '개 실패' : ''));
        closeModal(); fetchCompanies(); return;
      }
      var it = toAdd[idx];
      authFetch(API + '/auth/add-company', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: it.name, ceo: it.ceo, bizNo: it.bizNo, address: it.address, tel: it.tel, email: '' })
      }).then(function(r) { return r.json(); }).then(function(d) {
        if (d.success) done++; else fail++;
        addNext(idx + 1);
      }).catch(function() { fail++; addNext(idx + 1); });
    };
    addNext(0);
  };

  var isAdmin = user && (user.role === '관리자' || user.role === 'admin');

  var removeCompany = function(c) {
    setModal({
      type: 'danger',
      title: '이 항목을 삭제할까요?',
      message: '"' + c.name + '" 업체를 내 계정에서 해제합니다.\n해당 업체의 차량 데이터는 유지됩니다.',
      confirmText: '해제',
      onConfirm: function() {
        closeModalDialog();
        authFetch(API + '/auth/remove-company', {
          method: 'DELETE', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ companyId: c.id })
        }).then(function(r) { return r.json(); }).then(function(d) {
          if (d.success) { showToast(c.name + ' 해제 완료'); fetchCompanies(); }
          else { showToast(d.error || '해제 실패', 'err'); }
        }).catch(function() { showToast('서버 오류', 'err'); });
      }
    });
  };

  var doDeleteCompanyFull = function(c, force) {
    var url = API + '/admin/companies/' + c.id + (force ? '?force=true' : '');
    authFetch(url, { method: 'DELETE' })
      .then(function(r) { return r.json().then(function(d){ return { status: r.status, body: d }; }); })
      .then(function(res) {
        var d = res.body;
        if (res.status === 409 && d.error === 'multi_owner') {
          // 다중 소속: 사용자에게 선택권 제공
          setModal({
            type: 'danger',
            title: '여러 계정이 사용 중인 업체입니다',
            message: d.message + '\n\n계속하면 모든 데이터가 영구 삭제됩니다.',
            confirmText: '강제 삭제',
            onConfirm: function() { closeModalDialog(); doDeleteCompanyFull(c, true); }
          });
          return;
        }
        if (d.success) { showToast(c.name + ' 완전 삭제 완료'); fetchCompanies(); }
        else { showToast(d.error || '삭제 실패', 'err'); }
      }).catch(function() { showToast('서버 오류', 'err'); });
  };

  var deleteCompanyFull = function(c) {
    setModal({
      type: 'danger',
      title: '이 항목을 삭제할까요?',
      message: '[관리자] "' + c.name + '" 업체를 완전 삭제합니다.\n⚠️ 해당 업체의 차량, 인보이스, 서류 데이터가 모두 삭제됩니다.',
      confirmText: '삭제',
      onConfirm: function() {
        setModal({
          type: 'danger',
          title: '이 항목을 삭제할까요?',
          message: '이 작업은 되돌릴 수 없습니다.\n업체명: ' + c.name + '\n사업자번호: ' + (c.bizNo || '-'),
          confirmText: '삭제',
          onConfirm: function() { closeModalDialog(); doDeleteCompanyFull(c); }
        });
      }
    });
  };

  var resetZoom = function() { setImgScale(1); setImgPos({ x: 0, y: 0 }); };

  var filtered = companies.filter(function(c) {
    if (!search) return true;
    var s = search.toLowerCase();
    return (c.name || '').toLowerCase().indexOf(s) >= 0 || (c.bizNo || '').indexOf(s) >= 0 || (c.ceo || '').toLowerCase().indexOf(s) >= 0;
  });
  filtered.sort(function(a, b) {
    var va = a[sortKey] || ''; var vb = b[sortKey] || '';
    if (sortKey === 'carCount' || sortKey === 'pendingCount') { va = va || 0; vb = vb || 0; }
    if (va < vb) return sortDir === 'asc' ? -1 : 1;
    if (va > vb) return sortDir === 'asc' ? 1 : -1;
    return 0;
  });
  var toggleSort = function(key) { if (sortKey === key) setSortDir(sortDir === 'asc' ? 'desc' : 'asc'); else { setSortKey(key); setSortDir('asc'); } };
  var cardStyle = { background: '#fff', borderRadius: 12, border: '1px solid #eee', padding: 16, marginBottom: 10 };

  if (loading) return <div style={{ textAlign: 'center', padding: '60px 0', color: '#aaa' }}>로딩 중...</div>;

  // 이미지 뷰어 렌더 함수
  var renderImgViewer = function(src, h) {
    return <div style={{ overflow: 'hidden', borderRadius: 8, border: '1px solid #e5e7eb', minHeight: h || 400, height: h || 420, cursor: imgScale > 1 ? 'grab' : 'default', background: '#f1f5f9' }}
      onWheel={function(e) { e.preventDefault(); var d = e.deltaY > 0 ? 0.9 : 1.1; var ns = Math.min(Math.max(imgScale * d, 1), 5); setImgScale(ns); if (ns <= 1) setImgPos({ x: 0, y: 0 }); }}
      onMouseDown={function(e) { if (imgScale > 1) { setIsDragging(true); setDragStart({ x: e.clientX - imgPos.x, y: e.clientY - imgPos.y }); } }}
      onMouseMove={function(e) { if (isDragging && imgScale > 1) setImgPos({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y }); }}
      onMouseUp={function() { setIsDragging(false); }} onMouseLeave={function() { setIsDragging(false); }}
      onDoubleClick={function() { if (imgScale > 1) resetZoom(); else setImgScale(2.5); }}>
      <img src={src} alt="사업자등록증" draggable={false} style={{ width: '100%', height: '100%', objectFit: 'contain', transform: 'scale(' + imgScale + ') translate(' + (imgPos.x / imgScale) + 'px,' + (imgPos.y / imgScale) + 'px)', transition: isDragging ? 'none' : 'transform 0.2s', userSelect: 'none' }} />
    </div>;
  };

  // 업로드 영역 클릭/드래그 핸들러
  var openFilePicker = function() {
    var inp = document.createElement('input'); inp.type = 'file'; inp.accept = 'image/*';
    if (canBatch) inp.multiple = true;
    inp.onchange = function(ev) {
      if (ev.target.files.length > 1) handleBatchFiles(ev.target.files);
      else if (ev.target.files[0]) handleOcrFile(ev.target.files[0]);
    }; inp.click();
  };
  var onDrop = function(e) {
    e.preventDefault();
    if (e.dataTransfer.files.length > 1 && canBatch) handleBatchFiles(e.dataTransfer.files);
    else if (e.dataTransfer.files[0]) handleOcrFile(e.dataTransfer.files[0]);
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '16px 12px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: '#111' }}>업체 관리 ({companies.length})</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          {isAdmin && <button onClick={function() { if (activeId !== 0) switchCompany(0); }} style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid ' + (activeId === 0 ? '#2563eb' : '#d0d5dd'), background: activeId === 0 ? '#eff6ff' : '#fff', color: activeId === 0 ? '#2563eb' : '#475569', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>🌐 전체 업체 보기{activeId === 0 ? ' (현재)' : ''}</button>}
          <button onClick={function() { setAddOpen(true); }} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1B3A5C', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>+ 사업자 추가</button>
        </div>
      </div>

      <input value={search} onChange={function(e) { setSearch(e.target.value); }} placeholder="업체명, 사업자번호, 대표자 검색" style={{ width: '100%', boxSizing: 'border-box', padding: '10px 14px', borderRadius: 8, border: '1px solid #e0dfda', fontSize: 14, marginBottom: 12 }} />

      <div style={{ ...cardStyle, padding: 0, overflow: 'auto', maxHeight: 'calc(100vh - 220px)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead><tr style={{ background: '#f8f9fa', borderBottom: '2px solid #e5e7eb' }}>
            {[['name', '업체명'], ['bizNo', '사업자번호'], ['ceo', '대표자'], ['carCount', '차량 수'], ['pendingCount', '미처리']].map(function(col) {
              var thW = col[0] === 'bizNo' ? 130 : (col[0] === 'carCount' || col[0] === 'pendingCount' ? 70 : undefined);
              return <th key={col[0]} onClick={function() { toggleSort(col[0]); }} style={{ padding: '10px 12px', textAlign: col[0] === 'carCount' || col[0] === 'pendingCount' ? 'center' : 'left', cursor: 'pointer', fontWeight: 600, color: '#475569', fontSize: 12, position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 1, whiteSpace: 'nowrap', width: thW }}>{col[1]} {sortKey === col[0] ? (sortDir === 'asc' ? '↑' : '↓') : ''}</th>;
            })}
            <th style={{ padding: '10px 12px', textAlign: 'center', fontSize: 12, fontWeight: 600, color: '#475569', width: 80, position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 1 }}>전환</th>
            <th style={{ padding: '10px 12px', textAlign: 'center', fontSize: 12, fontWeight: 600, color: '#475569', width: 60, position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 1 }}>삭제</th>
          </tr></thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', padding: '30px 0', color: '#aaa' }}>소속 업체가 없습니다.</td></tr>}
            {filtered.map(function(c) {
              var isActive = c.id === activeId;
              return (<tr key={c.id} style={{ borderBottom: '1px solid #f0f0ec', background: isActive ? '#eff6ff' : '#fff', cursor: 'pointer' }} onClick={function() { if (!isActive) switchCompany(c.id); }}>
                <td style={{ padding: '10px 12px' }}><div style={{ fontWeight: 600, color: '#222' }}>{c.name}</div>{c.address && <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{c.address}</div>}</td>
                <td style={{ padding: '10px 12px', fontFamily: 'monospace', color: '#666', whiteSpace: 'nowrap', minWidth: 120 }}>{c.bizNo || '-'}</td>
                <td style={{ padding: '10px 12px', color: '#555' }}>{c.ceo || '-'}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center', fontWeight: 600 }}>{c.carCount}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>{c.pendingCount > 0 ? <span style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 8px', borderRadius: 5, fontSize: 11, fontWeight: 600 }}>{c.pendingCount}</span> : <span style={{ color: '#aaa' }}>0</span>}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }}>{isActive ? <span style={{ background: '#dbeafe', color: '#2563eb', padding: '3px 10px', borderRadius: 6, fontSize: 11, fontWeight: 600 }}>현재</span> : <button onClick={function(e) { e.stopPropagation(); switchCompany(c.id); }} style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid #d0d5dd', background: '#fff', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: '#475569' }}>전환</button>}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center' }} onClick={function(e) { e.stopPropagation(); }}>{isActive ? <span style={{ color: '#cbd5e1', fontSize: 14 }} title="현재 업체는 해제 불가">-</span> : <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}><button onClick={function() { removeCompany(c); }} style={{ padding: '3px 8px', borderRadius: 4, border: '1px solid #fca5a5', background: '#fff', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: '#dc2626' }} title="내 계정에서 해제">해제</button>{isAdmin && <button onClick={function() { deleteCompanyFull(c); }} style={{ padding: '3px 6px', borderRadius: 4, border: '1px solid #dc2626', background: '#dc2626', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: '#fff' }} title="업체 완전 삭제 (관리자)">삭제</button>}</div>}</td>
              </tr>);
            })}
          </tbody>
        </table>
      </div>

      {/* ════ 사업자 추가 모달 ════ */}
      {addOpen && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, minWidth: (ocrPreview || batchItems.length > 0) ? 800 : 400, maxWidth: 900, maxHeight: '90vh', overflow: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <div style={{ fontSize: 18, fontWeight: 800 }}>사업자 추가</div>
            <button onClick={closeModal} style={{ background: 'none', border: 'none', fontSize: 20, color: '#aaa', cursor: 'pointer' }}>×</button>
          </div>

          {/* ── 배치 모드 (2장 이상) ── */}
          {batchItems.length > 0 ? (
            <div>
              {/* 프로그레스 */}
              <div style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
                  <span style={{ color: '#555' }}>OCR 처리: {batchDone}/{batchItems.length}장</span>
                  {batchProcessing && <span style={{ color: '#f59e0b', fontWeight: 600 }}>처리 중...</span>}
                </div>
                <div style={{ height: 6, borderRadius: 3, background: '#f0f0ec' }}>
                  <div style={{ height: 6, borderRadius: 3, background: '#1B3A5C', width: (batchItems.length > 0 ? (batchDone / batchItems.length) * 100 : 0) + '%', transition: 'width 0.3s' }} />
                </div>
              </div>

              <div style={{ display: 'flex', gap: 16 }}>
                {/* 좌: 리스트 */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                      <thead><tr style={{ background: '#f8f9fa', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0 }}>
                        <th style={{ padding: '6px 4px', width: 28 }}><input type="checkbox" checked={batchItems.every(function(it) { return it.checked; })} onChange={function() { var allChecked = batchItems.every(function(it) { return it.checked; }); setBatchItems(function(prev) { return prev.map(function(it) { return Object.assign({}, it, { checked: !allChecked }); }); }); }} /></th>
                        <th style={{ padding: '6px 8px', textAlign: 'left' }}>파일명</th>
                        <th style={{ padding: '6px 8px', textAlign: 'left' }}>업체명</th>
                        <th style={{ padding: '6px 8px', textAlign: 'left' }}>대표자</th>
                        <th style={{ padding: '6px 8px', textAlign: 'left' }}>사업자번호</th>
                        <th style={{ padding: '6px 4px', width: 50, textAlign: 'center' }}>상태</th>
                      </tr></thead>
                      <tbody>{batchItems.map(function(it, idx) {
                        var statusIcon = it.status === 'done' ? '✅' : it.status === 'fail' ? '❌' : '⏳';
                        var rowBg = batchPreviewIdx === idx ? '#eff6ff' : idx % 2 === 1 ? '#fafafa' : '#fff';
                        return (<tr key={idx} style={{ background: rowBg, cursor: 'pointer' }} onClick={function() { setBatchPreviewIdx(idx); resetZoom(); }}>
                          <td style={{ padding: '5px 4px', textAlign: 'center' }} onClick={function(e) { e.stopPropagation(); }}><input type="checkbox" checked={it.checked} onChange={function() { setBatchItems(function(prev) { var next = prev.slice(); next[idx] = Object.assign({}, next[idx], { checked: !next[idx].checked }); return next; }); }} /></td>
                          <td style={{ padding: '5px 8px', fontSize: 11, color: '#666', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.file.name}</td>
                          <td style={{ padding: '5px 8px' }}>{it.status === 'fail' ? <input value={it.name} onChange={function(e) { var v = e.target.value; setBatchItems(function(prev) { var next = prev.slice(); next[idx] = Object.assign({}, next[idx], { name: v }); return next; }); }} onClick={function(e) { e.stopPropagation(); }} style={{ width: '100%', boxSizing: 'border-box', padding: '3px 6px', border: '1px solid #fca5a5', borderRadius: 4, fontSize: 12 }} placeholder="수동 입력" /> : <span style={{ fontWeight: 600 }}>{it.name || '-'}</span>}</td>
                          <td style={{ padding: '5px 8px', color: '#555' }}>{it.ceo || '-'}</td>
                          <td style={{ padding: '5px 8px', fontFamily: 'monospace', color: '#666', fontSize: 11 }}>{it.bizNo || '-'}</td>
                          <td style={{ padding: '5px 4px', textAlign: 'center' }}>{statusIcon}</td>
                        </tr>);
                      })}</tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                    <button onClick={closeModal} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13, color: '#555' }}>취소</button>
                    <button onClick={batchAddAll} disabled={addLoading || batchProcessing} style={{ flex: 2, padding: '10px 0', borderRadius: 8, border: 'none', background: (addLoading || batchProcessing) ? '#aaa' : '#1B3A5C', color: '#fff', cursor: (addLoading || batchProcessing) ? 'default' : 'pointer', fontSize: 13, fontWeight: 600 }}>
                      {addLoading ? '등록 중...' : '선택 업체 일괄 추가 (' + batchItems.filter(function(it) { return it.checked && it.name; }).length + '개)'}
                    </button>
                  </div>
                </div>
                {/* 우: 미리보기 */}
                {batchPreviewIdx !== null && batchItems[batchPreviewIdx] && (
                  <div style={{ width: 320, flexShrink: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 4 }}>{batchItems[batchPreviewIdx].file.name}</div>
                    {renderImgViewer(batchItems[batchPreviewIdx].preview, 360)}
                    <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4, textAlign: 'center' }}>휠: 확대 · 드래그: 이동 · 더블클릭: 원본</div>
                  </div>
                )}
              </div>
            </div>
          ) : !ocrPreview ? (
            /* ── 초기 화면 (업로드 + 수동 입력) ── */
            <div>
              <div onDragOver={function(e) { e.preventDefault(); }} onDrop={onDrop} onClick={openFilePicker}
                style={{ border: '2px dashed #d0d5dd', borderRadius: 10, padding: '24px 16px', textAlign: 'center', cursor: 'pointer', background: '#f8f9fa', marginBottom: 16 }}>
                <div style={{ fontSize: 28, marginBottom: 6 }}>📄</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#475569' }}>사업자등록증 업로드 (OCR 자동입력)</div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{canBatch ? '여러 장 동시 업로드 가능 · 클릭 또는 드래그' : '클릭 또는 드래그 · 수동 입력도 가능'}</div>
              </div>
              <div style={{ display: 'grid', gap: 10, marginBottom: 16 }}>
                {[['name', '업체명 *'], ['ceo', '대표자'], ['bizNo', '사업자번호'], ['address', '주소'], ['tel', '전화번호'], ['email', '이메일']].map(function(f) {
                  return <div key={f[0]}><label style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 3 }}>{f[1]}</label><input value={addForm[f[0]]} onChange={function(e) { var v = e.target.value; setAddForm(function(p) { var n = Object.assign({}, p); n[f[0]] = v; return n; }); }} style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #e0dfda', borderRadius: 6, fontSize: 13 }} /></div>;
                })}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={closeModal} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13, color: '#555' }}>취소</button>
                <button onClick={addCompany} disabled={addLoading} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: addLoading ? '#aaa' : '#1B3A5C', color: '#fff', cursor: addLoading ? 'default' : 'pointer', fontSize: 13, fontWeight: 600 }}>{addLoading ? '추가 중...' : '추가'}</button>
              </div>
            </div>
          ) : (
            /* ── 단일 OCR 모드 (좌우 분할) ── */
            <div style={{ display: 'flex', gap: 20 }}>
              <div style={{ width: '50%', flexShrink: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: '#475569' }}>사업자등록증 {ocrLoading && <span style={{ color: '#f59e0b' }}>OCR 인식 중...</span>}</span>
                  <button onClick={function() { setOcrPreview(null); setOcrFile(null); resetZoom(); }} style={{ fontSize: 11, padding: '2px 8px', border: '1px solid #d0d5dd', borderRadius: 4, background: '#fff', cursor: 'pointer', color: '#888' }}>다시 선택</button>
                </div>
                {renderImgViewer(ocrPreview, 420)}
                <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4, textAlign: 'center' }}>휠: 확대/축소 · 드래그: 이동 · 더블클릭: 원본</div>
              </div>
              <div style={{ width: '50%', padding: '0 0 0 4px' }}>
                {ocrLoading && <div style={{ background: '#fef9e7', borderRadius: 8, padding: '8px 12px', marginBottom: 10, fontSize: 12, color: '#92400e', fontWeight: 600 }}>OCR 인식 중...</div>}
                <div style={{ display: 'grid', gap: 10, marginBottom: 16 }}>
                  {[['name', '업체명 *'], ['ceo', '대표자'], ['bizNo', '사업자번호'], ['address', '주소'], ['tel', '전화번호'], ['email', '이메일']].map(function(f) {
                    return <div key={f[0]}><label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 3, fontWeight: 500 }}>{f[1]}</label><input value={addForm[f[0]]} onChange={function(e) { var v = e.target.value; setAddForm(function(p) { var n = Object.assign({}, p); n[f[0]] = v; return n; }); }} style={{ width: '100%', boxSizing: 'border-box', padding: '9px 12px', border: '1px solid #e0dfda', borderRadius: 6, fontSize: 13 }} /></div>;
                  })}
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={closeModal} style={{ flex: 1, padding: '11px 0', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13, color: '#555' }}>취소</button>
                  <button onClick={addCompany} disabled={addLoading || ocrLoading} style={{ flex: 1, padding: '11px 0', borderRadius: 8, border: 'none', background: (addLoading || ocrLoading) ? '#aaa' : '#1B3A5C', color: '#fff', cursor: (addLoading || ocrLoading) ? 'default' : 'pointer', fontSize: 13, fontWeight: 600 }}>{addLoading ? '추가 중...' : '추가'}</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>}
      {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModalDialog} />}
    </div>
  );
}

export default CompanyListPage;
